/**
 * External
 */
import { has } from "lodash";

/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";
import { Button, Spinner, Panel, PanelBody, PanelRow } from "@wordpress/components";
import { Fragment, useState } from "@wordpress/element";

/**
 * Internal dependencies.
 */
import { googlepagespeedapi as apiPs } from "./helpers-functions";

const PageSpeed = () => {
	// const { createNotice } = dispatch("core/notices");
	const [status, setStatus] = useState(false);
	const [spWithCache, setspWithCache] = useState(false);
	const [spWithOutCache, setspWithOutCache] = useState(false);

	const makeSpeedTest = async () => {
		setStatus("loading");
		const withCache = await apiPs(window.ahscUtils.const["homePage"]);
		const withOutCache = await apiPs(window.ahscUtils.const["homePage"] + "?no-cache=true");
		setStatus("loaded");
		setspWithCache(withCache);
		setspWithOutCache(withOutCache);
	};

	const reportComponent = (report) => {
		if (has(report, "error")) {
			return (
				<>
					<p>{__("An error occurred, please try again later.", "aruba-hispeed-cache")}</p>
				</>
			);
		}
	};

	if (false === status) {
		return (
			<Fragment>
				<PanelBody className={["center"]}>
					<Button variant="secondary" onClick={async () => makeSpeedTest()}>
						{__("Run Comparative PageSpeed", "aruba-hispeed-cache")}
					</Button>
				</PanelBody>
			</Fragment>
		);
	}

	// gift source https://dribbble.com/shots/4186967-Loading-Data-Animation
	if ("loading" === status) {
		return (
			<Fragment>
				<PanelBody title={__("Loading Parameters Without Cache.", "aruba-hispeed-cache")}>
					<span class="center">
						<Spinner
							style={{
								height: "calc(4px * 20)",
								width: "calc(4px * 20)",
							}}
						/>
					</span>
				</PanelBody>

				<PanelBody title={__("Loading Parameters With Cache.", "aruba-hispeed-cache")}>
					<span class="center">
						<Spinner
							style={{
								height: "calc(4px * 20)",
								width: "calc(4px * 20)",
							}}
						/>
					</span>
				</PanelBody>
			</Fragment>
		);
	}

	if ("loaded" === status) {
		return (
			<Fragment>
				<PanelBody title={__("Report Google PageSpeed Api with Cache", "aruba-hispeed-cache")}>
					{reportComponent(spWithCache)}
				</PanelBody>
				<PanelBody title={__("Report Google PageSpeed Api without Cache", "aruba-hispeed-cache")}>
					{reportComponent(spWithOutCache)}
				</PanelBody>
			</Fragment>
		);
	}
};

export default PageSpeed;
